<template>
    <div class="absolute top-0 right-0 m-2 z-20 flex flex-col">
        <div class="drawer drawer-end">
            <input id="my-drawer-4" type="checkbox" class="drawer-toggle" />
            <div class="drawer-content">
                <!-- Page content here -->
                <label for="my-drawer-4" tabindex="0" class="drawer-button btn btn-sm shadow-sm border border-base-content/5 w-10 h-10 side-menu-main">
                    <div class="indicator">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h7"
                            ></path>
                        </svg>
                    </div>                
                </label>
            </div> 
            <div class="drawer-side">
                <label for="my-drawer-4" aria-label="close sidebar" class="drawer-overlay"></label>
                <ul class="menu p-4 pt-2 w-80 min-h-full bg-base-200 text-base-content gap-1">
                    <div class="flex justify-between">
                        <div class=""></div> 
                        <div class="btn btn-square btn-sm btn-ghost m-1 close-z-100">
                            <button class="drawer-close-button" @click="toggleDrawer()">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <li :href="displayLink" class="w-full">
                        <a class="w-ttl px-2">
                            <div class="flex items-center">
                                <!-- commentout logo
                                <div
                                    class="avatar"
                                    v-if="mapData.logo_url"
                                >
                                    <div class="w-10 h-10 rounded">
                                        <img :src="mapData.logo_url" />
                                    </div>
                                </div>
                                -->
                                <div
                                    class="flex flex-col items-start text-sm mx-2"
                                    v-if="mapData.title"
                                >
                                    <div class="text-base-content font-bold break-words text-overflow-wrap w-txt">
                                        {{ mapData.title }}
                                    </div>
                                    <div class="text-base-content/80 font-bold text-xs break-words text-overflow-wrap w-txt">
                                        {{ mapData.sub_title }}
                                    </div>
                                </div>
                            </div>
                        </a>
                    </li>
                    <div class="divider my-1"></div>
                    <div v-if="parcelTitle" class="my-2 mx-2">
                        <div class="text-base-content font-bold break-words text-overflow-wrap">
                            {{ parcelTitle }}
                        </div>
                        <div class="text-base-content/80 font-bold break-words text-overflow-wrap">
                            {{ layerTitle }}
                        </div>
                        <div class="divider mb-1"></div>
                    </div>
                <!-- Sidebar content here -->
                <li v-if="parcelTitle">
                    <a :href="displayLink">
                        <span class="material-symbols-outlined pr-0 notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
                        </span>
                        <span>{{ trans.right_menu.main_map }}</span>
                    </a>
                </li>
                <li v-show="showSwitchLanguage" @click="$emit('toggled', 'localeBox'); toggleDrawer()">
                    <span>
                        <span class="material-symbols-outlined pr-0 notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>                    
                        </span>
                        <span>{{ trans.right_menu.language }}</span>
                    </span>
                </li>
                <!-- refresh btn -->
                <li v-show="showRefreshBtn" onClick="window.location.reload()">
                    <a>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            stroke-width="2"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            ></path>
                        </svg>
                        <span>{{ trans.right_menu.refresh }}</span>
                    </a>
                </li>
                <!-- fullscreen
                <li v-show="showFullscreen">
                    <span>
                        <fullscreen></fullscreen>
                        <span class="pl-0 self-center">{{ trans.right_menu.full_screen }}</span>
                    </span>
                </li>
                -->
                <!-- map setting -->
                <li @click="$emit('toggled', 'mapSetting'); toggleDrawer()">
                    <a>
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                                ></path>
                            </svg>
                        </span>
                        <span>{{ trans.right_menu.map_setting }}</span>
                    </a>
                </li>
                </ul>
            </div>
        </div>
        <div v-show="showSwitchLanguage" @click="$emit('toggled', 'localeBox')" class="btn btn-sm shadow-sm border border-base-content/5 w-10 h-10 mt-2 side-menu-language">
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"/></svg>                    
            </span>
        </div>
        <div v-if="isIframe" v-show="showNewTab" @click="openNewTab()" class="btn btn-sm shadow-sm border border-base-content/5 w-10 h-10 mt-2 side-menu-newtab">
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-120v-240h80v104l124-124 56 56-124 124h104v80H120Zm480 0v-80h104L580-324l56-56 124 124v-104h80v240H600ZM324-580 200-704v104h-80v-240h240v80H256l124 124-56 56Zm312 0-56-56 124-124H600v-80h240v240h-80v-104L636-580Z"/></svg>            
            </span>
        </div>
    </div>
</template>

<script>
import Fullscreen from './Fullscreen';

export default {
    props: {
        showZoomBtn: {
            type: Boolean,
            required: true
        },
        showFullscreen: {
            type: Boolean,
            required: true
        },
        showRefreshBtn: {
            type: Boolean,
            required: true
        },
        onClickZoom: {
            type: Function,
            required: true
        },
        goToMainMap: {
            type: Function,
            required: true
        },
        showNewTab: {
            type: Boolean,
            required: true
        },
        displayLink: {
            type: String,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        showSwitchLanguage: {
            type: Boolean,
            required: true
        },
        mapData: {
            type: Object,
            required: true
        },
        layerTitle: {
            type: String,
            default: ''
        },
        parcelTitle: {
            type: String,
            default: ''
        },
    },
    components: {
        Fullscreen
    },
    methods: {
        openNewTab() {
            window.open(this.displayLink, '_blank');
        },
        toggleDrawer() {
            const drawerToggle = document.querySelector('#my-drawer-4');
            drawerToggle.click();
        },
    },
    computed: {
        isIframe() {
            return window.top !== window.self;
        }
    },
};
</script>

<style>
    .w-ttl{
        width: 18rem;
    }
    .w-txt{
        width: 14rem;
    }
    @media (max-width: 768px) {
    .drawer-side {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      overflow-y: auto;
      transform: translateX(-100%);
    }

    .drawer-toggle:checked ~ .drawer-side {
      transform: translateX(0);
      overflow-x: hidden;
    }
  }
</style>